import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as actions from '../../redux/actions/actions-guide';
import Button from '../../components/Button';
import SearchBar from '../../components/SearchBar';
import BreadCrumb from '../../components/Breadcrumb';
import Loader from '../../components/Loader';

class Guide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVal: ''
    };
    props.getGuidelist();
  }


  deleteGuide = (id) => {
    confirmAlert({
      title: 'Delete Guide',
      message: 'Are you sure to delete the Guide?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.deleteGuide(id)
              .then(() => {
                toast.success('Deleted Successfully');
              }).catch((error) => {
                toast.error(error.message);
              });
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleTableFilter = (search) => {
    this.setState({ searchVal: search });
  }

  setTableOption = () => (this.props.guideList && this.props.tableLoading ? <Loader /> : 'No Data Found');

  render() {
    const searchVal = this.state.searchVal.toLowerCase();
    const guide = this.props.guideList.filter((item) => item.Title.toLowerCase().includes(searchVal));

    const columns = [{
      dataField: 'Title',
      text: 'Guide Name'
    }, {
      dataField: 'SlugURL',
      text: 'Slug URL'
    }, {
      dataField: 'CreatedDateTime',
      text: 'Created at',
      formatter: (cell, row) => (
        new Date(cell).toLocaleDateString()
      ),
      sort: true
    }, {
      dataField: 'Id',
      text: 'Actions',
      headerStyle: {
        width: '140px'
      },
      formatter: (cell, row) => (
        <>
          <span
            role="presentation"
            className="fa fa-pencil-alt tableEdit"
            onClick={() => this.props.history.push(`/guide-editor/${cell}`)}
          />
          <span
            role="presentation"
            className="fa fa-trash tableDelete"
            onClick={() => this.deleteGuide(cell)}
          />
        </>
      )
    }];

    const defaultSorted = [{
      dataField: 'CreatedDateTime',
      order: 'desc'
    }];

    return (
      <div>
        <div className="container">
          <BreadCrumb currentPage="Guide" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    {/* <span className="fa fa-book-reader cardTitle"> Guide</span> */}
                    <SearchBar
                      placeholder="Search by Guide Name"
                      handleChange={(e) => this.handleTableFilter(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2 text-right">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.push('/guide-editor/0')}
                    >
                      <span className="fas fa-plus" />
                      {' '}
                      Add New
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">
                <BootstrapTable
                  keyField="Id"
                  data={guide}
                  columns={columns}
                  pagination={paginationFactory()}
                  defaultSorted={defaultSorted}
                  noDataIndication={() => this.setTableOption()}
                  hover
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Guide.defaultProps = {
  tableLoading: false,
  guideList: null,
  getGuidelist: null,
  deleteGuide: null
};

Guide.propTypes = {
  tableLoading: PropTypes.bool,
  guideList: PropTypes.array,
  getGuidelist: PropTypes.func,
  deleteGuide: PropTypes.func
};

const mapStateToProps = ({ guide }) => ({
  tableLoading: guide.tableLoading,
  guideList: guide.guideList
});

const mapDispatchToProps = (dispatch) => ({

  getGuidelist: () => dispatch(actions.fetchGuide()),
  deleteGuide: (id) => dispatch(actions.deleteGuide(id))

});

export default connect(mapStateToProps, mapDispatchToProps)(Guide);
